module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/80c7503180eff7feac884ffc8dc49dcf.png";